import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function XcapePortfolio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gray-200 selection:text-black">
      <title>Xcape | Aventuras y Experiencias | Mood Agency</title>
      <meta name="description" content="Caso de éxito Xcape: Plataforma digital para la gestión y reserva de experiencias de aventura." />
      
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-blue-100 via-gray-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-gray-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-gray-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-gray-300 rounded-full absolute opacity-60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO
            </span>
          </div>
          
          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            Xcape
          </h1>
          
          <p className="max-w-3xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            Explora lo extraordinario: una puerta digital a aventuras inolvidables.
          </p>
        </div>
      </section>

      {/* Key Metrics */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">+50</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Destinos Únicos</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">95%</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Satisfacción del Cliente</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">Fast</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Booking System</p>
          </div>
        </div>
      </section>

      {/* The Context */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Contexto</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            Xcape necesitaba una plataforma que capturara la emoción de sus viajes de aventura y facilitara el proceso de reserva para una audiencia joven y dinámica. El objetivo era simplificar la logística compleja detrás de cada destino.
          </p>
        </div>
      </section>

      {/* The Challenge */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Desafío<br/>Logístico
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              El reto principal consistió en integrar un sistema de reservas multi-destino con disponibilidad en tiempo real, manteniendo una estética visual impactante y centrada en el contenido multimedia.
            </p>
          </div>
          <div className="space-y-12">
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Sistema de Reservas</h3>
              <p className="font-sans text-gray-500">Automatización de pagos y confirmaciones para múltiples destinos.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Contenido Visual</h3>
              <p className="font-sans text-gray-500">Optimización de galerías y videos para una carga rápida sin perder calidad.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Escalabilidad</h3>
              <p className="font-sans text-gray-500">Estructura preparada para la adición constante de nuevos paquetes y ofertas.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">La Solución</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Booking Engine</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Desarrollamos un motor de reservas a medida que gestiona cupos, fechas y servicios adicionales de forma automática.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">UI/UX Inmersiva</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Diseñamos una interfaz que prioriza la narrativa visual, transportando al usuario al destino desde el primer clic.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Optimización Móvil</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Aseguramos una experiencia de reserva fluida y rápida, optimizada específicamente para usuarios en movimiento.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact */}
      <section className="py-32 px-6 bg-black text-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-20 uppercase tracking-widest">Resultado</h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="font-display text-2xl md:text-4xl leading-tight mb-12">
              "Xcape ahora cuenta con una plataforma que no solo vende viajes, sino que inspira aventuras. La eficiencia del sistema ha permitido un crecimiento exponencial en sus reservas directas."
            </p>
            <div className="w-20 h-1 bg-white mx-auto opacity-30"></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
